import React, { useEffect, useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  Box,
  Typography,
  ButtonBase,
  Avatar,
  Stack,
  Divider,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupIcon from "@mui/icons-material/Group";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import BarChartIcon from "@mui/icons-material/BarChart";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SettingsIcon from "@mui/icons-material/Settings";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CategoryIcon from "@mui/icons-material/Category";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import AddIcon from "@mui/icons-material/Add";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import TableRowsIcon from "@mui/icons-material/TableRows";
import TableViewIcon from "@mui/icons-material/TableView";
import dashboard from "../../assets/Dashboard.svg";
import sales from "../../assets/sales.svg";
import itemManage from "../../assets/itemManage.svg";
import offerManage from "../../assets/offers.png";
import stoksManage from "../../assets/stokss.png";
import userManage from "../../assets/userManage.svg";
import franchiseManage from "../../assets/franchiseManage.svg";
import orderTrack from "../../assets/orderManage.svg";
import stocksmanager from "../../assets/stockmanage.svg";
import Bell from "../../assets/Bell.svg";
import Tracks from "../../assets/track.svg";
import BKLogo from "../../assets/trans logo bk (1) 1.svg";

import BytingKornerLogo from "../../assets/Byting_Korner_logo.png"; // Replace with your path
import ChatSupportIcon from "../../assets/chat-support.svg"; // Replace with your path
import SupportCard from "../Support/Support";

const drawerWidth = 280;
// const drawerWidth = 320;
const Sidebar = ({ mobileOpen, handleDrawerToggle, userRole }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [hoveredPath, setHoveredPath] = useState(null);
  const [openSupportModal, setOpenSupportModal] = useState(false);
  const [openSection, setOpenSection] = useState(null);

  useEffect(() => {
    if (location.pathname) {
      setHoveredPath(location.pathname);
    }
  }, [location.pathname]);

  const isActive = (path) => location.pathname === path;

  const toggleSection = (section) => {
    setOpenSection((prev) => (prev === section ? null : section));
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const menuItemStyle = (path) => ({
    backgroundColor: isActive(path) ? "#FFD33D" : "transparent",
    color: isActive(path) ? "black" : "#A1A1A1",
    borderRadius: "8px",
    cursor: "pointer",
    px: 2,
    "&:hover": {
      backgroundColor: "#FFEDB1",
      color: "black",
    },
  });

  const handleNavigate = (path) => {
    navigate(path);
    if (isMobile && handleDrawerToggle) {
      handleDrawerToggle();
    }
  };

  const iconStyle = (path, isHovered = false) => {
    return {
      minWidth: 32,
      // mr: 1,
      "& img": {
        width: 20,
        height: 20,
        filter: isHovered ? "brightness(0) saturate(100%)" : "none",
        transition: "filter 0.3s",
      },
    };
  };

  const isSectionActive = (prefix) => location.pathname.startsWith(prefix);

  const HoverIcon = ({ src, alt, isHovered, isActive }) => (
    <Box
      component="span"
      sx={{
        width: 20,
        height: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& img": {
          width: "100%",
          height: "100%",
          objectFit: "contain",
          filter:
            isHovered || isActive ? "brightness(0) saturate(100%)" : "none",
          transition: "filter 0.3s",
        },
      }}
    >
      <img src={src} alt={alt} />
    </Box>
  );

  const supportItem = {
    text: "Support",
    subtitle: "Answers here",
    icon: (
      <img
        src={ChatSupportIcon}
        alt="Chat Support"
        style={{ width: "24px", height: "24px" }}
      />
    ),
    path: "/support",
  };

  const users = JSON.parse(localStorage.getItem("userDetails")) || {};
  const userRoles = users.role_name || "Super Admin";

  const drawerContent = (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: 3 }}>
        <Box
          component="img"
          src={BKLogo}
          alt="Byting Korner Logo"
          sx={{
            width: 48,
            height: 48,
            objectFit: "contain",
          }}
        />

        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: "1rem",
              color: "#fff",
              lineHeight: 1.2,
            }}
          >
            Byting Korner
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#A1A1A1",
              fontSize: "0.75rem",
              fontWeight: 400,
            }}
          >
            {userRoles}
          </Typography>
        </Box>
      </Box>

      <List>
        {userRole === "Admin" && (
          <>
            <Box sx={{ mx: 2, my: 1 }}>
              <Typography
                sx={{ color: "#888", fontSize: "10px", fontWeight: 600, mb: 1 }}
              >
                {/* SUPER ADMIN */}
                MAIN
              </Typography>
              <ListItem
                button
                onClick={() => handleNavigate("/dashboard")}
                sx={{
                  ...menuItemStyle("/dashboard"),
                  display: "flex",
                  alignItems: "center", // ✅ Vertically align icon and text
                }}
                onMouseEnter={() => setHoveredPath("/dashboard")}
                onMouseLeave={() => setHoveredPath(null)}
              >
                <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                  <HoverIcon
                    src={dashboard}
                    alt="Dashboard"
                    path="/dashboard"
                    isHovered={hoveredPath === "/dashboard"}
                    isActive={isActive("/dashboard")}
                  />
                </ListItemIcon>

                <ListItemText
                  primary="Dashboard"
                  primaryTypographyProps={{ fontSize: "0.85rem" }}
                />
              </ListItem>
            </Box>

            {/* Item details*/}
            <Box sx={{ mx: 2, my: 1 }}>
              <ListItem
                button
                onClick={() => toggleSection("item")}
                onMouseEnter={() => setHoveredPath("/itemManage")}
                onMouseLeave={() => setHoveredPath(null)}
                sx={{
                  backgroundColor: location.pathname.startsWith("/item-details")
                    ? "#fcd34d"
                    : "transparent",
                  color: isSectionActive("/item-details") ? "black" : "#A1A1A1",
                  borderRadius: "8px",
                  px: 2,
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#fcd34d", color: "#000" },
                }}
              >
                <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                  <HoverIcon
                    src={itemManage}
                    alt="Item Manager"
                    path="/itemManage"
                    isHovered={
                      hoveredPath === "/itemManage" ||
                      location.pathname.startsWith("/item-details")
                    }
                  />
                </ListItemIcon>

                <ListItemText
                  primary="Item Manager"
                  primaryTypographyProps={{ fontSize: "0.85rem" }}
                />
                {openSection === "item" ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </Box>

            <Collapse in={openSection === "item"} timeout="auto" unmountOnExit>
              <List
                component="div"
                disablePadding
                sx={{
                  pl: 4,
                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 8,
                    bottom: 8,
                    left: 35,
                    width: "2px",
                    backgroundColor: "#A1A1A1",
                    borderRadius: "2px",
                  },
                }}
              >
                {[
                  { text: "Stock Inventory", path: "/item-details/stock" },
                  { text: "Food Item", path: "/item-details/food" },
                  // { text: 'Register Item', path: '/item-details/register-item' },
                  { text: "Stock Category", path: "/item-details/stocks" },
                  { text: "Food Category", path: "/item-details/foods" },
                  { text: "Stock Unit", path: "/item-details/stock-unit" },
                  // { text: 'Register Category', path: '/item-details/register-category' },
                ].map(({ text, path }) => (
                  <Box key={path} sx={{ mx: 2, my: 1 }}>
                    <ListItem
                      button
                      onClick={() => handleNavigate(path)}
                      sx={menuItemStyle(path)}
                    >
                      <ListItemText
                        primary={text}
                        primaryTypographyProps={{ fontSize: "0.8rem" }}
                      />
                    </ListItem>
                  </Box>
                ))}
              </List>
            </Collapse>

            {/* category details*/}
            <Box sx={{ mx: 2, my: 1 }}>
              <ListItem
                button
                onClick={() => toggleSection("category")}
                onMouseEnter={() => setHoveredPath("/franchiseManage")}
                onMouseLeave={() => setHoveredPath(null)}
                sx={{
                  backgroundColor: location.pathname.startsWith(
                    "/franchise-manager"
                  )
                    ? "#fcd34d"
                    : "transparent",
                  color: isSectionActive("/franchise-manager")
                    ? "black"
                    : "#A1A1A1",
                  borderRadius: "8px",
                  px: 2,
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#fcd34d", color: "#000" },
                }}
              >
                <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                  <HoverIcon
                    src={franchiseManage}
                    alt="Franchise Manager"
                    path="/franchiseManage"
                    isHovered={
                      hoveredPath === "/franchiseManage" ||
                      location.pathname.startsWith("/franchise-manager")
                    }
                  />
                </ListItemIcon>

                <ListItemText
                  primary="Franchise Manager"
                  primaryTypographyProps={{ fontSize: "0.85rem" }}
                />
                {openSection === "category" ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </Box>

            <Collapse
              in={openSection === "category"}
              timeout="auto"
              unmountOnExit
            >
              <List
                component="div"
                disablePadding
                sx={{
                  pl: 4,
                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 8,
                    bottom: 8,
                    left: 35,
                    width: "2px",
                    backgroundColor: "#A1A1A1",
                    borderRadius: "2px",
                  },
                }}
              >
                {[
                  {
                    text: "View Franchise",
                    icon: <TableViewIcon />,
                    path: "/franchise-manager/franchise-details",
                  },
                  {
                    text: "View Master Franchise",
                    icon: <TableRowsIcon />,
                    path: "/franchise-manager/master-franchise-details",
                  },
                  // { text: 'Register Franchise', icon: <SupervisorAccountIcon />, path: '/franchise-manager/register-franchise' },
                  // { text: 'Register Master Franchise', icon: <SupervisorAccountIcon />, path: '/franchise-manager/register-master-franchise' },
                ].map(({ text, path }) => (
                  <Box key={path} sx={{ mx: 2, my: 1 }}>
                    <ListItem
                      button
                      onClick={() => handleNavigate(path)}
                      sx={menuItemStyle(path)}
                    >
                      <ListItemText
                        primary={text}
                        primaryTypographyProps={{ fontSize: "0.8rem" }}
                      />
                    </ListItem>
                  </Box>
                ))}
              </List>
            </Collapse>

            <Box sx={{ mx: 2, my: 1 }}>
              <ListItem
                button
                onClick={() => toggleSection("track")}
                onMouseEnter={() => setHoveredPath("/orderTrack")}
                onMouseLeave={() => setHoveredPath(null)}
                sx={{
                  backgroundColor: location.pathname.startsWith(
                    "/order-tracker"
                  )
                    ? "#fcd34d"
                    : "transparent",
                  color: isSectionActive("/order-tracker")
                    ? "black"
                    : "#A1A1A1",
                  borderRadius: "8px",
                  px: 2,
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#fcd34d", color: "#000" },
                }}
              >
                <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                  <HoverIcon
                    src={orderTrack}
                    alt="Order Track"
                    path="/orderTrack"
                    isHovered={
                      hoveredPath === "/orderTrack" ||
                      location.pathname.startsWith("/order-tracker")
                    }
                  />
                </ListItemIcon>

                <ListItemText
                  primary="Order Track"
                  primaryTypographyProps={{ fontSize: "0.85rem" }}
                />
                {openSection === "track" ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </Box>

            <Collapse in={openSection === "track"} timeout="auto" unmountOnExit>
              <List
                component="div"
                disablePadding
                sx={{
                  pl: 4,
                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 8,
                    bottom: 8,
                    left: 35,
                    width: "2px",
                    backgroundColor: "#A1A1A1",
                    borderRadius: "2px",
                  },
                }}
              >
                {[
                  {
                    text: "MF Order Tracker ",
                    path: "/order-tracker/masterfranchise-order-tracker",
                  },
                  {
                    text: "Franchise Order Tracker ",
                    path: "/order-tracker/franchise-order-tracker",
                  },
                  {
                    text: "Force Order",
                    path: "/order-tracker/force-order",
                  },
                ].map(({ text, path }) => (
                  <Box key={path} sx={{ mx: 2, my: 1 }}>
                    <ListItem
                      button
                      onClick={() => handleNavigate(path)}
                      sx={menuItemStyle(path)}
                    >
                      <ListItemText
                        primary={text}
                        primaryTypographyProps={{ fontSize: "0.8rem" }}
                      />
                    </ListItem>
                  </Box>
                ))}
              </List>
            </Collapse>

            <Box sx={{ mx: 2, my: 1 }}>
              <ListItem
                button
                onClick={() => toggleSection("stock")}
                onMouseEnter={() => setHoveredPath("/stockmanage")}
                onMouseLeave={() => setHoveredPath(null)}
                sx={{
                  backgroundColor: location.pathname.startsWith(
                    "/stock-manager"
                  )
                    ? "#fcd34d"
                    : "transparent",
                  color: isSectionActive("/stock-manager")
                    ? "black"
                    : "#A1A1A1",
                  borderRadius: "8px",
                  px: 2,
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#fcd34d", color: "#000" },
                }}
              >
                <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                  <HoverIcon
                    src={stoksManage}
                    alt="Stock Manager"
                    path="/stockmanage"
                    isHovered={
                      hoveredPath === "/stockmanage" ||
                      location.pathname.startsWith("/stock-manager")
                    }
                  />
                </ListItemIcon>

                <ListItemText
                  primary="Stock Manager"
                  primaryTypographyProps={{ fontSize: "0.85rem" }}
                />
                {openSection === "stock" ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </Box>

            <Collapse in={openSection === "stock"} timeout="auto" unmountOnExit>
              <List
                component="div"
                disablePadding
                sx={{
                  pl: 4,
                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 8,
                    bottom: 8,
                    left: 35,
                    width: "2px",
                    backgroundColor: "#A1A1A1",
                    borderRadius: "2px",
                  },
                }}
              >
                {[
                  {
                    text: "Current Stock ",
                    path: "/stock-manager/current-stock",
                  },
                  {
                    text: "Stock Adjustment History ",
                    path: "/stock-manager/stock-adjustment",
                  },
                ].map(({ text, path }) => (
                  <Box key={path} sx={{ mx: 2, my: 1 }}>
                    <ListItem
                      button
                      onClick={() => handleNavigate(path)}
                      sx={menuItemStyle(path)}
                    >
                      <ListItemText
                        primary={text}
                        primaryTypographyProps={{ fontSize: "0.8rem" }}
                      />
                    </ListItem>
                  </Box>
                ))}
              </List>
            </Collapse>

            <Box sx={{ mx: 2, my: 1 }}>
              <ListItem
                button
                onClick={() => toggleSection("offer")}
                onMouseEnter={() => setHoveredPath("/offer")}
                onMouseLeave={() => setHoveredPath(null)}
                sx={{
                  backgroundColor: location.pathname.startsWith("/offer")
                    ? "#fcd34d"
                    : "transparent",
                  color: isSectionActive("/offer") ? "black" : "#A1A1A1",
                  borderRadius: "8px",
                  px: 2,
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#fcd34d", color: "#000" },
                }}
              >
                <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                  <HoverIcon
                    src={offerManage}
                    alt="Offer Manager"
                    path="/offer"
                    isHovered={
                      hoveredPath === "/offer" ||
                      location.pathname.startsWith("/offer")
                    }
                  />
                </ListItemIcon>

                <ListItemText
                  primary="Offer Manager"
                  primaryTypographyProps={{ fontSize: "0.85rem" }}
                />
                {openSection === "offer" ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </Box>

            <Collapse in={openSection === "offer"} timeout="auto" unmountOnExit>
              <List
                component="div"
                disablePadding
                sx={{
                  pl: 4,
                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 8,
                    bottom: 8,
                    left: 35,
                    width: "2px",
                    backgroundColor: "#A1A1A1",
                    borderRadius: "2px",
                  },
                }}
              >
                {[
                  { text: "Create New Coupen ", path: "/offer/coupen-manager" },
                  {
                    text: "Set Sidebar Offer Image ",
                    path: "/offer/sidebar-image",
                  },
                  // { text: 'Stock Adjustment History ', path: '/stock-manager/stock-adjustment' },
                ].map(({ text, path }) => (
                  <Box key={path} sx={{ mx: 2, my: 1 }}>
                    <ListItem
                      button
                      onClick={() => handleNavigate(path)}
                      sx={menuItemStyle(path)}
                    >
                      <ListItemText
                        primary={text}
                        primaryTypographyProps={{ fontSize: "0.8rem" }}
                      />
                    </ListItem>
                  </Box>
                ))}
              </List>
            </Collapse>

            {/* category */}
            {[
              {
                text: "User & Role",
                icon: (
                  <HoverIcon
                    src={userManage}
                    alt="User & Role"
                    path="/role-management/table"
                    isHovered={hoveredPath === "/role-management/table"}
                    isActive={isActive("/role-management/table")}
                  />
                ),
                path: "/role-management/table",
              },

              {
                text: "Sales & Reports",
                icon: (
                  <HoverIcon
                    src={sales}
                    alt="Sales Reports"
                    path="/sales-reports"
                    isHovered={hoveredPath === "/sales-reports"}
                    isActive={isActive("/sales-reports")}
                  />
                ),
                path: "/sales-reports",
              },
              {
                text: "Category Alarm",
                icon: (
                  <CategoryIcon
                    sx={{
                      fontSize: 20,
                      color:
                        hoveredPath === "/category-alarm" ||
                        isActive("/category-alarm")
                          ? "black"
                          : "#A1A1A1",
                      transition: "color 0.3s",
                    }}
                  />
                ),
                path: "/category-alarm",
              },
              {
                text: "Force order franchise",
                icon: (
                  <CategoryIcon
                    sx={{
                      fontSize: 20,
                      color:
                        hoveredPath === "/force-order-franchise" ||
                        isActive("/force-order-franchise")
                          ? "black"
                          : "#A1A1A1",
                      transition: "color 0.3s",
                    }}
                  />
                ),
                path: "/force-order-franchise",
              },
              {
                text: "Payment Limit",
                icon: (
                  <AccountBalanceWalletIcon
                    sx={{
                      fontSize: 20,
                      color:
                        hoveredPath === "/payment-limit" ||
                        isActive("/payment-limit")
                          ? "black"
                          : "#A1A1A1",
                      transition: "color 0.3s",
                    }}
                  />
                ),
                path: "/payment-limit",
              },
              {
                text: "Dynamic Offer",
                icon: (
                  <LocalOfferIcon
                    sx={{
                      fontSize: 20,
                      color:
                        hoveredPath === "/dynamic-offer" ||
                        isActive("/dynamic-offer")
                          ? "black"
                          : "#A1A1A1",
                      transition: "color 0.3s",
                    }}
                  />
                ),
                path: "/dynamic-offer",
              },
              // { text: 'Notification Manager',  icon: <HoverIcon src={Bell} alt="Notification Manager" path="/notification-history" isHovered={hoveredPath === '/notification-history'} isActive={isActive('/notification-history')}  />, path: '/notification-history' },
              // { text: 'Track Ticket Status',  icon: <HoverIcon src={Tracks} alt="Track Ticket Status" path="/track-ticket" isHovered={hoveredPath === '/track-ticket'} isActive={isActive('/track-ticket')}  />, path: '/track-ticket' },
            ].map((item, index) =>
              item.divider ? (
                <Divider
                  key={index}
                  sx={{ backgroundColor: "#444", my: 1, mx: 2 }}
                />
              ) : item.sectionLabel ? (
                <Box key={index} sx={{ mx: 2, my: 2 }}>
                  <Typography
                    sx={{ color: "#888", fontSize: "10px", fontWeight: 600 }}
                  >
                    {item.sectionLabel}
                  </Typography>
                </Box>
              ) : (
                <Box key={item.text} sx={{ mx: 2, my: 1 }}>
                  <ListItem
                    button
                    onClick={() => handleNavigate(item.path)}
                    onMouseEnter={() => setHoveredPath(item.path)}
                    onMouseLeave={() => setHoveredPath(null)}
                    sx={menuItemStyle(item.path)}
                  >
                    <ListItemIcon
                      sx={{ ...iconStyle("item.path"), minWidth: 32, mr: 1 }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.text}
                      primaryTypographyProps={{ fontSize: "0.85rem" }}
                    />
                  </ListItem>
                </Box>
              )
            )}

            <Box sx={{ mx: 2, my: 1 }}>
              <ListItem
                button
                onClick={() => toggleSection("view-route")}
                onMouseEnter={() => setHoveredPath("/route-manager/viewroute")}
                onMouseLeave={() => setHoveredPath(null)}
                sx={{
                  backgroundColor: location.pathname.startsWith(
                    "/route-manager"
                  )
                    ? "#fcd34d"
                    : "transparent",
                  color: isSectionActive("/route-manager")
                    ? "black"
                    : "#A1A1A1",
                  borderRadius: "8px",
                  px: 2,
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#fcd34d", color: "#000" },
                }}
              >
                <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                  <HoverIcon
                    src={stocksmanager}
                    alt="Route Manager"
                    path="/route-manager/viewroute"
                    isHovered={
                      hoveredPath === "/route-manager/viewroute" ||
                      location.pathname.startsWith("/route-manager")
                    }
                  />
                </ListItemIcon>

                <ListItemText
                  primary="Route Manager"
                  primaryTypographyProps={{ fontSize: "0.85rem" }}
                />
                {openSection === "view-route" ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </Box>

            <Collapse
              in={openSection === "view-route"}
              timeout="auto"
              unmountOnExit
            >
              <List
                component="div"
                disablePadding
                sx={{
                  pl: 4,
                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 8,
                    bottom: 8,
                    left: 35,
                    width: "2px",
                    backgroundColor: "#A1A1A1",
                    borderRadius: "2px",
                  },
                }}
              >
                {[
                  { text: "View Route ", path: "/route-manager/viewroute" },
                  {
                    text: "Route Allocation Manager",
                    path: "/route-manager/route-allocation",
                  },
                ].map(({ text, path }) => (
                  <Box key={path} sx={{ mx: 2, my: 1 }}>
                    <ListItem
                      button
                      onClick={() => handleNavigate(path)}
                      sx={menuItemStyle(path)}
                    >
                      <ListItemText
                        primary={text}
                        primaryTypographyProps={{ fontSize: "0.8rem" }}
                      />
                    </ListItem>
                  </Box>
                ))}
              </List>
            </Collapse>
          </>
        )}

        {userRole === "Master Franchise" && (
          <>
            <Box sx={{ mx: 2, my: 1 }}>
              <Typography
                sx={{ color: "#888", fontSize: "10px", fontWeight: 600, mb: 1 }}
              >
                MASTER FRANCHISE (dev)
              </Typography>

              <ListItem
                button
                onClick={() => handleNavigate("/dashboard-master")}
                sx={{
                  ...menuItemStyle("/dashboard-master"),
                  display: "flex",
                  alignItems: "center", // ✅ Vertically align icon and text
                }}
                onMouseEnter={() => setHoveredPath("/dashboard-master")}
                onMouseLeave={() => setHoveredPath(null)}
              >
                <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                  <HoverIcon
                    src={dashboard}
                    alt="Dashboard"
                    path="/dashboard-master"
                    isHovered={hoveredPath === "/dashboard-master"}
                    isActive={isActive("/dashboard-master")}
                  />
                </ListItemIcon>

                <ListItemText
                  primary="Dashboard"
                  primaryTypographyProps={{ fontSize: "0.85rem" }}
                />
              </ListItem>
            </Box>

            <Box sx={{ mx: 2, my: 1 }}>
              <ListItem
                button
                onClick={() => toggleSection("stocks")}
                onMouseEnter={() => setHoveredPath("/stockmanager")}
                onMouseLeave={() => setHoveredPath(null)}
                sx={{
                  backgroundColor: location.pathname.startsWith("/manage-stock")
                    ? "#fcd34d"
                    : "transparent",
                  color: isSectionActive("/manage-stock") ? "black" : "#A1A1A1",
                  borderRadius: "8px",
                  px: 2,
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#fcd34d", color: "#000" },
                }}
              >
                <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                  <HoverIcon
                    src={stocksmanager}
                    alt="Stock Manager"
                    path="/managestock"
                    isHovered={
                      hoveredPath === "/managestock" ||
                      location.pathname.startsWith("/manage-stock")
                    }
                  />
                </ListItemIcon>

                <ListItemText
                  primary="Stock Manager"
                  primaryTypographyProps={{ fontSize: "0.85rem" }}
                />
                {openSection === "stocks" ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </Box>

            <Collapse
              in={openSection === "stocks"}
              timeout="auto"
              unmountOnExit
            >
              <List
                component="div"
                disablePadding
                sx={{
                  pl: 4,
                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 8,
                    bottom: 8,
                    left: 35,
                    width: "2px",
                    backgroundColor: "#A1A1A1",
                    borderRadius: "2px",
                  },
                }}
              >
                {[
                  {
                    text: "Current Stock ",
                    path: "/manage-stock/current-stockMF",
                  },
                  {
                    text: "Stock Request History ",
                    path: "/manage-stock/stock-request",
                  },
                ].map(({ text, path }) => (
                  <Box key={path} sx={{ mx: 2, my: 1 }}>
                    <ListItem
                      button
                      onClick={() => handleNavigate(path)}
                      sx={menuItemStyle(path)}
                    >
                      <ListItemText
                        primary={text}
                        primaryTypographyProps={{ fontSize: "0.8rem" }}
                      />
                    </ListItem>
                  </Box>
                ))}
              </List>
            </Collapse>

            {[
              {
                text: "Franchise Order Tracker",
                icon: (
                  <HoverIcon
                    src={orderTrack}
                    alt="Franchise Order Tracker"
                    path="/franachise-order-track"
                    isHovered={hoveredPath === "/franachise-order-track"}
                    isActive={isActive("/franachise-order-track")}
                  />
                ),
                path: "/franachise-order-track",
              },
              {
                text: "Franchise Manager",
                icon: (
                  <HoverIcon
                    src={franchiseManage}
                    alt="Franchise Manager"
                    path="/manage-franchise"
                    isHovered={hoveredPath === "/manage-franchise"}
                    isActive={isActive("/manage-franchise")}
                  />
                ),
                path: "/manage-franchise",
              },
              {
                text: "Tempo Manger",
                icon: (
                  <HoverIcon
                    src={sales}
                    alt="Tempo Manger"
                    path="/tempo-manager"
                    isHovered={hoveredPath === "/tempo-manager"}
                    isActive={isActive("/tempo-manager")}
                  />
                ),
                path: "/tempo-manager",
              },
              {
                text: "Sales & Reports",
                icon: (
                  <HoverIcon
                    src={sales}
                    alt="Sales & Reports"
                    path="/sales-reports-MF"
                    isHovered={hoveredPath === "/sales-reports-MF"}
                    isActive={isActive("/sales-reports-MF")}
                  />
                ),
                path: "/sales-reports-MF",
              },
              {
                text: "Offers Redeem",
                icon: (
                  <HoverIcon
                    src={offerManage}
                    alt="Offers Redeem"
                    path="/offer/redeem"
                    isHovered={hoveredPath === "/offer/redeem"}
                    isActive={isActive("/offer/redeem")}
                  />
                ),
                path: "/offer/redeem",
              },
            ].map((item, index) => (
              <Box key={item.text} sx={{ mx: 2, my: 1 }}>
                <ListItem
                  button
                  onClick={() => handleNavigate(item.path)}
                  sx={menuItemStyle(item.path)}
                >
                  <ListItemIcon sx={iconStyle(item.path)}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.text}
                    primaryTypographyProps={{ fontSize: "0.85rem" }}
                  />
                </ListItem>
              </Box>
            ))}

            <Box sx={{ mx: 2, my: 1 }}>
              <ListItem
                button
                onClick={() => toggleSection("view-route")}
                onMouseEnter={() => setHoveredPath("/route-manager/viewroute")}
                onMouseLeave={() => setHoveredPath(null)}
                sx={{
                  backgroundColor: location.pathname.startsWith(
                    "/route-manager"
                  )
                    ? "#fcd34d"
                    : "transparent",
                  color: isSectionActive("/route-manager")
                    ? "black"
                    : "#A1A1A1",
                  borderRadius: "8px",
                  px: 2,
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#fcd34d", color: "#000" },
                }}
              >
                <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                  <HoverIcon
                    src={stocksmanager}
                    alt="Route Manager"
                    path="/route-manager/viewroute"
                    isHovered={
                      hoveredPath === "/route-manager/viewroute" ||
                      location.pathname.startsWith("/route-manager")
                    }
                  />
                </ListItemIcon>

                <ListItemText
                  primary="Route Manager"
                  primaryTypographyProps={{ fontSize: "0.85rem" }}
                />
                {openSection === "view-route" ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </Box>

            <Collapse
              in={openSection === "view-route"}
              timeout="auto"
              unmountOnExit
            >
              <List
                component="div"
                disablePadding
                sx={{
                  pl: 4,
                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 8,
                    bottom: 8,
                    left: 35,
                    width: "2px",
                    backgroundColor: "#A1A1A1",
                    borderRadius: "2px",
                  },
                }}
              >
                {[
                  { text: "View Route ", path: "/route-manager/viewroute" },
                  {
                    text: "Route Allocation Manager",
                    path: "/route-manager/route-allocation",
                  },
                ].map(({ text, path }) => (
                  <Box key={path} sx={{ mx: 2, my: 1 }}>
                    <ListItem
                      button
                      onClick={() => handleNavigate(path)}
                      sx={menuItemStyle(path)}
                    >
                      <ListItemText
                        primary={text}
                        primaryTypographyProps={{ fontSize: "0.8rem" }}
                      />
                    </ListItem>
                  </Box>
                ))}
              </List>
            </Collapse>
          </>
        )}
      </List>

      {/* <Box sx={{ p: 2, mt: 'auto' }}>
        <ButtonBase
         onClick={() => setOpenSupportModal(true)}
          sx={{
            width: '100%',
            borderRadius: '12px',
            bgcolor: '#c5f12c',
            color: '#000',
            p: 1.5,
            textAlign: 'left',
            justifyContent: 'flex-start',
            '&:hover': {
              bgcolor: '#bde72a',
            },
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2} width="100%">
            <Avatar sx={{ bgcolor: '#1e1e1e', width: 40, height: 40 }}>
              <img src={ChatSupportIcon} alt="Chat Support" style={{ width: '24px', height: '24px' }} />
            </Avatar>
            <Box flexGrow={1}>
              <Typography variant="subtitle1" fontWeight="bold" fontSize="0.85rem">
                Contact Support
              </Typography>
              <Typography variant="body2" fontSize="0.75rem">
                Answers here
              </Typography>
            </Box>
            <ArrowForwardIosIcon fontSize="small" />
          </Stack>
        </ButtonBase>
      </Box> */}
      {openSupportModal && (
        <SupportCard
          open={openSupportModal}
          onClose={() => setOpenSupportModal(false)}
          state={{
            state: "",
            notify: "",
            mtFranchise: "",
            franchise: "",
            openAddUser: false,
            openClearUser: false,
          }}
          changeNameValue={() => {}}
          handleOpenAddUser={() => {}}
          handleCloseAddUser={() => {}}
          handleOpenClearUser={() => {}}
          handleCloseClearUser={() => {}}
        />
      )}
    </>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
    >
      {/* Drawer logic */}
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={isMobile ? mobileOpen : true}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            backgroundColor: "#1c1c1e",
            color: "#fff",
          },
        }}
      >
        {drawerContent}
      </Drawer>
    </Box>
  );
};

export default Sidebar;
